<template>
    <div> 
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header>
         <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Pagá en Comercios
            </b-card-header>
            <b-card-body>
                <div class="row form-group">
                    <div class="col-md-12">
                        <label>A quien desea pagarle?</label> 
                        <KitsBusqueda url="Account/GetCommerces" v-model="model.Comercio" :currentValue="model.Comercio"/>
                    </div>
                </div>   
                <div class="row form-group">
                    <div class="col-md-12">
                        <money-with-indicator v-model="model.Importe" v-on:validatedOK="onSaldoOK"/>
                    </div>
                </div>   
                <div class="row form-group">
                    <div class="col-md-12">
                        <label>Referencia</label> 
                        <base-input v-model="model.Referencia" placeholder="Motivo"></base-input>
                    </div>
                </div>   
                <div class="row form-group" >
                    <div class="col-md-12">
                        <save-button text="Pagar" @click="onEnviarDinero" :disabled="btnPagarDisabled"/>
                    </div>
                </div>
            </b-card-body>
        </b-card>      
        <pin-validation ref="pin-validation"
            :showModal.sync="showModalPinValidation"
            v-on:validPin="onValidPin"
            v-on:loadUsePaymentPin="onLoadUsePaymentPin">
        </pin-validation>
    </div>
</template>

<style>
</style>

<script>

    // ******************** Select ********************//
    import Vue from 'vue'
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    import 'vue-select/dist/vue-select.css';
    // ******************** Select ********************//

    import axiosHelpers from '@/helpers/axiosHelpers';
    import notificationHelpers from '@/helpers/notificationHelpers';
    import KitsBusqueda from '@/components/KitsBusqueda';

    import JsonCSV from 'vue-json-csv' 
    Vue.component('downloadCsv', JsonCSV)
    import PinValidation from '@/views/Pin/PinValidation';
    import MoneyWithIndicator from '@/components/Custom/MoneyWithIndicator';
    
    export default {
        components: { 
            KitsBusqueda,
            "pin-validation": PinValidation,
            "money-with-indicator": MoneyWithIndicator
        },
        data(){
            return {
                model: {
                    Importe: 0,
                    Referencia: '',
                    Comercio: null
                },
                usePaymentPin: false,
                showModalPinValidation: false,
                btnPagarDisabled: false
            }
        },
        methods: {
            onEnviarDinero() {
                this.validate();
            },
            validate() {
                if(this.model.Comercio == null){
                    notificationHelpers.showWarning('Alerta', 'Debe seleccionar a quien pagarle', this);
                    return;
                }
                if(this.model.Importe <= 0){
                    notificationHelpers.showWarning('Alerta', 'El importe debe ser superior a 0', this);
                    return;
                }
                if(this.model.Referencia == ''){
                    notificationHelpers.showWarning('Alerta', 'Debe ingresar una referencia', this);
                    return;
                }

                this.pinValidate();
            },
            enviarDinero(){
                let req = { Amount: this.model.Importe, Reference: this.model.Referencia, DestinyAccountID: this.model.Comercio.EntityID};

                let context = this
                axiosHelpers.axiosPost('Account/PayCommerce', req, this, function(data){ 
                    if(data.ResponseVM.Success){
                        notificationHelpers.showSuccess('Exito', 'Se pago al comercio correctamente', context);
                        context.model.Importe = 0;
                        context.model.Referencia = '';
                    }
                });
            },
            onValidPin(val) {
                if(val) {
                    this.enviarDinero();
                }
            },
            onLoadUsePaymentPin(val) {
                this.usePaymentPin = val;
            },
            pinValidate() {
                if(this.usePaymentPin) {
                    this.showModalPinValidation = true;
                } else {
                    this.enviarDinero();
                }
            },
            onSaldoOK(val) {
                this.btnPagarDisabled = !val;
            }
        }
    }
</script>